import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { load, isProfileLoaded, resetProfileLoaded } from 'modules/HorseRacing/reducers/horseProfile';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';

import { canonicalLink } from 'utils/seoUtils';
import { racingProfileLink } from 'modules/HorseRacing/utils';

import SwitchBtns from 'modules/Common/components/SwitchBtns';
import ProfileHeading from 'modules/HorseRacing/components/Profiles/ProfileHeading';
import HorseProfileDetails from 'modules/HorseRacing/components/Profiles/HorseProfileDetails';

require('./HorseProfilePage.scss');

@standardAsyncConnect([
  {
    dispatch: ({ params: { horseId } }) => load(horseId),
    preventResolve: ({ state }) => isProfileLoaded(state),
    state: state => ({ profile: state.horseRacing.horseProfile.profile }),
    errorState: state => state.horseRacing.horseProfile.error,
    refreshInterval: 60000,
    preserveRefresh: true,
    reset: () => resetProfileLoaded(),
    handleError: true,
    reportStatus: true
  }
])
export default class HorseProfilePageContainer extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    profile: PropTypes.object,
    params: PropTypes.object,
    children: PropTypes.node.isRequired
  };

  render() {
    const {
      routes,
      children,
      profile,
      profile: {
        name,
        horse_reference: {
          id
        } = {}
      } = {}
    } = this.props;

    return (
      <div className="horse-profile">
        <MetaDataWrapper helmetProps={{...canonicalLink(routes, {horseId: id})}}/>
        <ProfileHeading classPrefix="horse" type="HORSE" {...{id, name}}/>
        <HorseProfileDetails {...{profile}} />
        <SwitchBtns buttons={[
          {href: racingProfileLink('horse', id), isIndex: true, text: "All Results"},
          {href: `${racingProfileLink('horse', id)}/future-entries`, text: "Future Entries"}
        ]}/>
        {children && React.cloneElement(children, { profile })}
      </div>
    );
  }

  renderError() {
    return (
      <div className="horse-profile">
        <h1>Horse not found</h1>
        <div className="horse-profile-not-found">The horse you were looking for could not be found</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/Profiles/HorseProfilePageContainer.js